// ============================================================================
// handleClaudeCode — Drop-in thunk similar to handleAgentIQ / handleOpenClaw
//
// Usage:
//   dispatch(handleClaudeCode("Fix the bug in orderProcessor.ts"));
//   dispatch(handleClaudeCode("Build a notification system", true)); // re-init
// ============================================================================
import { connectToClaudeCode, disconnectFromClaudeCode, sendClaudeCodeMessage } from "./claudeCodeThunk";
import { selectIsClaudeCodeConnected, selectClaudeCodeConnectionStatus, selectClaudeCodeServerUrl, selectClaudeCodeModel, selectClaudeCodeApiKey } from "./claudeCodeSlice";
import { addMessageConversation } from "containers/ChatGPT/reducer";
// ---------------------------------------------------------------------------
// Main thunk
// ---------------------------------------------------------------------------
export function handleClaudeCode(prompt, shouldInit = false) {
    return async (dispatch, getState) => {
        const isConnected = selectIsClaudeCodeConnected(getState());
        // ------------------------------------------------------------------
        // 1. Connect if needed
        // ------------------------------------------------------------------
        if (shouldInit || !isConnected) {
            if (shouldInit && isConnected) {
                dispatch(disconnectFromClaudeCode());
            }
            const url = selectClaudeCodeServerUrl(getState());
            const model = selectClaudeCodeModel(getState());
            const apiKey = selectClaudeCodeApiKey(getState());
            if (!url) {
                dispatch(addMessageConversation({
                    user: "Aible",
                    text: "Claude Code server URL not configured. Please enter it in the settings.",
                    date: new Date()
                }));
                return;
            }
            dispatch(connectToClaudeCode(url, model, apiKey || undefined));
            // Wait for connection (up to 15s — config POST + WS connect)
            const connected = await waitForConnection(getState, 15_000);
            if (!connected) {
                dispatch(addMessageConversation({
                    user: "Aible",
                    text: "Could not connect to Claude Code server. Please verify the server is running.",
                    date: new Date()
                }));
                return;
            }
        }
        // ------------------------------------------------------------------
        // 2. Send the message
        // ------------------------------------------------------------------
        dispatch(sendClaudeCodeMessage(prompt));
    };
}
// ---------------------------------------------------------------------------
// Helper: wait for the WebSocket connection to establish
// ---------------------------------------------------------------------------
function waitForConnection(getState, timeoutMs) {
    return new Promise((resolve) => {
        const start = Date.now();
        const check = () => {
            if (selectIsClaudeCodeConnected(getState())) {
                resolve(true);
                return;
            }
            const status = selectClaudeCodeConnectionStatus(getState());
            if (status === "error") {
                resolve(false);
                return;
            }
            if (Date.now() - start > timeoutMs) {
                resolve(false);
                return;
            }
            setTimeout(check, 100);
        };
        check();
    });
}
